export const hrefContainsPattern = (
  href: string,
  pattern = '.herokuapp.com',
): void => {
  if (href.includes(pattern)) {
    alert('You are using the wrong URL this may cause authentication errors.');
  }
};
